import React from 'react';
import styles from './table.module.scss';


export default class TableColumnHeader extends React.Component {
    constructor(props) {
        super(props);
        this.directionChanged = this.directionChanged.bind(this);
    }
    
    directionChanged() {
        const isDescending = !this.props.isDescending;
        if (this.props.onSortDirectionChanged) {
            this.props.onSortDirectionChanged(this.props.sortProperty, isDescending);
        }
    }

    render() {
        return (
            <th>
                {this.props.sortProperty && <button onClick={this.directionChanged}><span>{this.props.header}</span><span className={this.props.isDefault ? styles.up_down : this.props.isDescending ? styles.down : styles.up}></span></button>}
                {!this.props.sortProperty && <span>{this.props.header}</span>}
            </th>
        );
    }
}